import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

function TermsConditions() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="row py-5 px-sm-5">
          <div className="col">
            <h1 className="text-center fw-bold">Terms & Conditions</h1>
            <p className="mt-3">
              <strong>Terms & Conditions</strong> ("Agreement") entered into by and between 
              <strong>Color Kingdon</strong> ("Company") and you ("Customer").
            </p>
            <ul className="mt-4">
              <li>
                <h5 className="fw-bold">1. Introduction</h5>
                <p>
                  Welcome to <strong>Color Kingdon</strong> – premium colouring books from Sikar. 
                  By accessing and using our website, you agree to comply with and be bound by 
                  these terms and conditions. Please read them carefully before placing any order.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">2. Products and Orders</h5>
                <p>
                  <strong>Product Information:</strong> We offer premium colouring books with 
                  hand-drawn designs, thick 120-160 GSM bleed-proof paper for kids, adults, 
                  and educational use.
                </p>
                <p>
                  <strong>Availability:</strong> Products subject to stock availability. We 
                  reserve the right to modify designs or discontinue products without notice.
                </p>
                <p>
                  <strong>Order Confirmation:</strong> Order acknowledgment email does not 
                  confirm acceptance. We reserve the right to cancel orders due to stock, 
                  pricing errors, or other valid reasons.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">3. Pricing and Payment</h5>
                <p>
                  <strong>Prices:</strong> Displayed on website, inclusive of GST. Subject to change.
                </p>
                <p>
                  <strong>Payment Methods:</strong>
                </p>
                <ul>
                  <li>Cash on Delivery (COD) + ₹59 fee</li>
                  <li>Razorpay: Cards, UPI, Net Banking, Wallets</li>
                </ul>
                <p><strong>Orders processed only after payment confirmation.</strong></p>
              </li>
              <li>
                <h5 className="fw-bold">4. Shipping Charges</h5>
                <p>
                  <strong>Standard Shipping:</strong> ₹79 flat rate across India
                </p>
                <p>
                  <strong>FREE Shipping:</strong> Orders above ₹499
                </p>
                <p>
                  <strong>Bulk Orders:</strong> Special rates available – contact for quotes
                </p>
              </li>
              <li>
                <h5 className="fw-bold">5. Shipping and Delivery</h5>
                <p>
                  <strong>Delivery:</strong> Pan-India via Shipway, DTDC, Delhivery (3-10 business days)
                </p>
                <p>
                  <strong>Delays:</strong> Not liable for delays due to courier issues, 
                  natural calamities, or incorrect address provided by customer.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">6. Returns and Refunds</h5>
                <p>
                  <strong>7-Day Returns:</strong> Unused books in original packaging (no writing/colouring)
                </p>
                <p>
                  <strong>Damaged/Defective:</strong> Report within 48 hours with photos for free replacement/refund
                </p>
                <p>
                  <strong>Non-Returnable:</strong> Used books, custom orders, digital downloads, clearance items
                </p>
                <p>See detailed <a href="/return-policy" className="text-success text-decoration-none">Return Policy</a></p>
              </li>
              <li>
                <h5 className="fw-bold">7. Intellectual Property</h5>
                <p>
                  All designs, illustrations, and content are copyrighted by Color Kingdon. 
                  Personal use allowed; commercial reproduction prohibited without permission.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">8. Limitation of Liability</h5>
                <p>
                  Color Kingdon not liable for indirect damages, lost profits, or consequential damages. 
                  Total liability limited to order value.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">9. Governing Law</h5>
                <p>
                  These terms governed by laws of India. Disputes subject to jurisdiction of 
                  courts in Sikar, Rajasthan.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">10. Contact Information</h5>
                <p>
                  <strong>Color Kingdon</strong><br/>
                  📍 Sikar, Rajasthan, India<br/>
                  📧 <a href="mailto:support@colorkingdon.in" className="text-success text-decoration-none">support@colorkingdon.in</a><br/>
                  📞 <a href="tel:+919251952096" className="text-success text-decoration-none">+91 9251952096</a><br/>
                  🌐 <a href="https://colorkingdon.in" className="text-success text-decoration-none">www.colorkingdon.in</a>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default TermsConditions;